import React from 'react'

export const LockOpenIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `path-1-inside-1_${Date.now()}`)
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M6.6155 9H15V7C15 6.16667 14.7083 5.45833 14.125 4.875C13.5417 4.29167 12.8333 4 12 4C11.1667 4 10.4583 4.29167 9.875 4.875C9.29167 5.45833 9 6.16667 9 7H8C8 5.88583 8.38817 4.94067 9.1645 4.1645C9.94067 3.38817 10.8858 3 12 3C13.1142 3 14.0593 3.38817 14.8355 4.1645C15.6118 4.94067 16 5.88583 16 7V9H17.3845C17.832 9 18.2132 9.15733 18.528 9.472C18.8427 9.78683 19 10.168 19 10.6155V19.3845C19 19.832 18.8427 20.2132 18.528 20.528C18.2132 20.8427 17.832 21 17.3845 21H6.6155C6.168 21 5.78683 20.8427 5.472 20.528C5.15733 20.2132 5 19.832 5 19.3845V10.6155C5 10.168 5.15733 9.78683 5.472 9.472C5.78683 9.15733 6.168 9 6.6155 9ZM6.6155 20H17.3845C17.564 20 17.7115 19.9423 17.827 19.827C17.9423 19.7115 18 19.564 18 19.3845V10.6155C18 10.436 17.9423 10.2885 17.827 10.173C17.7115 10.0577 17.564 10 17.3845 10H6.6155C6.436 10 6.2885 10.0577 6.173 10.173C6.05767 10.2885 6 10.436 6 10.6155V19.3845C6 19.564 6.05767 19.7115 6.173 19.827C6.2885 19.9423 6.436 20 6.6155 20ZM12 16.5C12.4218 16.5 12.7773 16.3554 13.0663 16.0663C13.3554 15.7773 13.5 15.4218 13.5 15C13.5 14.5782 13.3554 14.2227 13.0663 13.9338C12.7773 13.6446 12.4218 13.5 12 13.5C11.5782 13.5 11.2228 13.6446 10.9338 13.9338C10.6446 14.2227 10.5 14.5782 10.5 15C10.5 15.4218 10.6446 15.7773 10.9338 16.0663C11.2228 16.3554 11.5782 16.5 12 16.5Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
